import Container from "@/components/ui/Container";
import SectionLabel from "@/components/ui/SectionLabel";
import GradientHeading from "@/components/ui/GradientHeading";
import GradientCountBadge from "@/components/ui/icons/GradientCountBadge";

const steps = [
  {
    title: "Фиксирует фактическое использование кода",
    desc: "Агент записывает, какие методы и библиотеки используются в продуктовой среде",
    tag: "Недостижимые уязвимые пути не влияют на оценку риска",
    pill: (
      <>
        Overhead в production
        <span className="text-coral">&nbsp;&lt;3% CPU</span>
      </>
    ),
  },
  {
    title: "Связывает уязвимость с операцией",
    desc: "Показывает, где возникает проблема и через какой сценарий она активируется",
    tag: "Разработчик видит точку входа",
  },
  {
    title: "Оценивает реальный риск",
    desc: "Учитывает доступен ли сервис из интернета, путь к данным и роль сервиса в архитектуре",
    tag: "Приоритет определяется по достижимости и влиянию",
  },
  {
    title: "Блокирует атаки в процессе",
    desc: "Агент живёт внутри процесса и видит каждый вызов изнутри — блокирует попытки эксплуатации JNDI-, SQL- инъекции, console exploits",
    tag: "Без изменений в коде и логике приложения",
  },
];

export default function HowItWorksSection() {
  return (
    <section className="rounded-[50px] bg-surface py-[60px] min-[478px]:py-[100px] xl:py-[120px]">
      <Container>
        <div className="xl:grid xl:grid-cols-2 xl:gap-5">
          <div className="xl:sticky xl:top-[140px] xl:self-start xl:mb-[70px]">
            <SectionLabel>Как это работает</SectionLabel>
            <GradientHeading className="mt-3 xl:tracking-[-1.2px]">
              Как работает модуль
            </GradientHeading>
            <p className="mt-[30px] text-[16px] font-medium leading-[1.3] text-ink xl:max-w-[607px] xl:text-[18px]">
              Анализ происходит в реальном времени на основе фактического
              трафика — без отдельного сканирования
            </p>
          </div>

          <div className="relative mt-[60px] flex flex-col gap-2.5 min-[478px]:gap-5 xl:mt-0">
            <span
              aria-hidden
              className="pointer-events-none absolute inset-y-0 left-1/2 w-1 -translate-x-1/2 bg-white"
            />
            {steps.map((step, i) => (
              <div
                key={step.title}
                className="relative flex flex-col rounded-[25px] bg-white px-5 py-[26px] md:px-9 xl:min-h-[266px]"
              >
                <div className="flex flex-col items-start gap-2.5 md:flex-row md:items-center md:justify-between md:gap-4">
                  <GradientCountBadge>{i + 1}</GradientCountBadge>
                  {step.pill && (
                    <span className="flex w-full items-center justify-center rounded-[5px] border-[1.5px] border-coral-400 px-2 py-[10px] text-[14px] font-medium leading-none text-ink md:w-auto md:justify-start md:px-[21px]">
                      {step.pill}
                    </span>
                  )}
                </div>

                <h3 className="mt-[23px] text-[21px] font-bold leading-none tracking-[-0.21px] text-navy">
                  {step.title}
                </h3>

                <p className="mt-6 text-[16px] font-medium leading-[1.3] text-ink">
                  {step.desc}
                </p>

                <span className="mt-6 self-start rounded-[5px] bg-surface px-[21px] py-[10px] text-[14px] font-medium leading-none text-ink xl:mt-auto">
                  {step.tag}
                </span>
              </div>
            ))}
          </div>
        </div>
      </Container>
    </section>
  );
}
